<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo.png" alt="logo图" />
    </div>
    <!-- <p class="title">行道雄安科技有限公司</p> -->
    <p class="title">行道京雄（北京）信息技术有限公司</p>
    <p class="address_tel_fax">
      <span>地址：河北省保定市雄县保静公路北侧001号S5栋211号</span>
    </p>
    <p class="email_wx">
      <span>Tel：16633330117</span>
      <span>邮箱：bd@xdwalker.cn</span>
      <!-- <span>微信号：xxx</span> -->

      <p class="address_tel_fax">
        <img style="display: inline-block; height: 18px;" src="@/assets/img/filings-icon.jpg" alt="" srcset="">
        <a href= "https://beian.mps.gov.cn/#/query/webSearch?code=13310202000172" rel="noreferrer" target="_blank">冀公网安备13310202000189号</a >
        &nbsp;<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2022027797号 </a>
      </p>
    </p>
    <p class="copy">
      Copyright &copy; 2021 -
      <!-- {{ new Date().getFullYear() }} 行道雄安科技有限公司 -->
      {{ new Date().getFullYear() }} 行道京雄（北京）信息技术有限公司

    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 45px;
  height: 45px;
  margin: 50px auto 20px;
}
.logo img {
  height: 100%;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue